// extracted by mini-css-extract-plugin
export var label = "_c5-1";
export var reminder = "_c5-0";